import sortByOrder from './sort-by-order';

const sortGroupedWidgetsList = (groupedList) =>
  groupedList.map((group) => ({
    ...group,
    items: sortByOrder(group.items),
  }));

export default sortGroupedWidgetsList;
